import React, { useCallback, useLayoutEffect } from 'react';
import { saveAs } from 'file-saver';
import { Box, IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import {
  Close as CloseIcon,
  Download as DownloadIcon
} from '@mui/icons-material';
import {
  backdropStyles,
  closeButtonStyles,
  downloadButtonStyles,
  imageContainerStyles,
  imageStyles
} from './styles';

const ViewImage = ({ src, onClose, fileType }) => {
  // Disable scroll on body while portal shown
  useLayoutEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'visible';
    };
  }, []);

  const downloadImage = useCallback(() => {
    const extension = fileType.split('/')[1];
    saveAs(src, `image.${extension}`, { type: fileType });
  }, [fileType]);

  return (
    <Box sx={backdropStyles}>
      <Box sx={imageContainerStyles}>
        <IconButton
          size="small"
          aria-label="Close"
          onClick={onClose}
          sx={closeButtonStyles}
        >
          <CloseIcon />
        </IconButton>

        <img style={imageStyles} src={src} />

        <IconButton
          aria-label="Download image"
          sx={downloadButtonStyles}
          onClick={downloadImage}
        >
          <DownloadIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

ViewImage.propTypes = {
  src: PropTypes.string.isRequired,
  fileType: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
};

export default ViewImage;
